module.exports = __webpack_public_path__ + "img/istj.c6e0d5ca.png";